import { Details, Margin } from "@mui/icons-material";

export default {
  app: {
    title: 'Pet contest',
    subtitle: 'Noah\'s Ark Contest Administration Dashboard',
  },
  dashboard: {
    totalContests: 'Total Contests',
    activeContests: 'Active',
    pendingContests: 'Pending',
    revenue: 'Revenue',
    profit: 'Profit',
    // ...más traducciones
  },
  buttonsforms: {
    TestImages: 'Test Images',
    createContest: 'Create Contest',
    createSponsorship: 'Create Sponsorship',
    ListCouponPasses: 'List Coupon Passes',
    ListPassCodes: 'List Pass Codes',
    ManagePlatforms: 'Manage Platforms',
    Update: 'Update',
    Less: 'Less',
    More: 'More',
    Actions: 'Actions',
    Close: 'Close',
    Cancel: 'Cancel',
    ambassadorManagement: 'Ambassadors',
    reportManagement: 'Sponsors Reports',
    searchPlaceholder: 'Search contests by name or sponsor...',
    generateWordDoc: 'Generate Word Doc',
    floatingButtonCreate: 'Create',
    floatingButtonLists: 'Lists',
    floatingButtonMoreOptions: 'More Options',
    contestsFound: 'contests found',
    contestFound: 'contest found',
    noContestsFound: 'No contests found',
    searchResultsFor: 'for "{term}"',
    refreshContests: 'Refresh contest list',
    refreshingContests: 'Refreshing contests...',
    deleteTag: 'Delete Tag',
  },
  menufilters: {
    Allcontests: 'Contests',
    Active: 'Active',
    Sponsored: 'Sponsored',
    ProposalLinked: 'PetFlix proposal',
    Membersonly: 'Members only',
    Subscribersonly: 'Subscribers only',
    Cancel: 'Cancel',
    Codes: 'Codes',
    Status: 'Status',
    CreatedAt: 'Created At',
    Name: 'Name',
    Uses: 'Uses',
    Used: 'Used',
    Available: 'Available',
    AvailableContests: 'Available',
    UnavailableContests: 'Not available',
  },
  contestcard: {
    profit: 'Profit',
    margin: 'Margin',
    roi: 'ROI',
    participants: 'Participants',
    totalrevenue: 'Total Revenue',
    duedate: 'Due Date',
    medialimits: 'Media Limits',
    entryfee: 'Entry Fee',
    sponsor: 'Sponsor',
    noahsark: 'Noah\'s Ark',
    accesslevel: 'Access Level',
    upto: 'Up to',
    images: 'images',
    videos: 'videos',
    approve: 'Approve',
    startSuccess: 'Contest started successfully! Total participants: {count}',
    startMinParticipantsNotice: 'To approve and start the contest, at least {min} participants are required. Currently {current} are registered.',
    startError: 'Could not start the contest. Please try again.',
    startConnectionError: 'Connection error while starting the contest.',
    reject: 'Reject',
    contestCancel: 'Contest Cancel',
    reactivateContest: 'Reactivate Contest',
    min: 'min',
    max: 'max',
    status: {
      pending: 'Pending',
      approved: 'Approved',
      rejected: 'Rejected',
      active: 'Active',
      completed: 'Completed',
      cancelled: 'Cancelled'
    },
    phase: {
      upcoming: 'Upcoming',
      submissions_open: 'Submissions Open',
      submissions_closed: 'Submissions Closed',
      voting_open: 'Voting Open',
      voting_closed: 'Voting Closed',
      completed: 'Completed'
    },
    sendsponsorship: 'Send Sponsorship Paylink',
    sendWinners: 'Send Winners',
    viewWinners: 'View Winners',
    viewsponsor: 'View Sponsor',
    viewparticipants: 'View Participants',
    editcontest: 'Edit Contest',
    viewvoteboosterreport: 'View Vote Booster Report',
    viewtagstatistics: 'View Tag Statistics',
    viewinvoice: 'View Invoice',
    viewdetails: 'View Details',
    deletecontest: 'Delete Contest',
    confirmDeleteTitle: 'Delete contest',
    confirmDeleteMessage: 'Are you sure you want to delete the contest "{name}"? This action cannot be undone.',
    confirmDeleteLinkedMessage: 'The contest "{name}" is linked to proposal {proposalNumber} from {sponsorName} (PetFlix Sponsorship Builder). The proposal will remain in PetFlix, but deleting this contest permanently removes the link, the sponsor, and the synced prize. Do you want to continue?',
    deleteSuccess: 'Contest deleted successfully.',
    deleteError: 'Error deleting the contest.',
    deleteConnectionError: 'Connection error while deleting the contest.',
    noSponsor: 'No sponsor',
    unnamedSponsor: 'Unnamed sponsor',
    availableLabel: 'Available',
    notAvailableLabel: 'Not available',
    reasonCancelled: 'Not available: the contest was cancelled.',
    reasonRejected: 'Not available: the contest was rejected.',
    reasonPendingApproval: 'Not available: pending approval.',
    reasonCompleted: 'Not available: the contest has already ended ({date}).',
    reasonVotingEnded: 'Not available: voting ended on {date}.',
    reasonSubmissionsClosed: 'Not available: submissions closed on {date}.',
    reasonNotStarted: 'Not available: the contest starts on {date}.',
    reasonAwaitingVoting: 'Not available: waiting for voting to open on {date}.',
    reasonVotingOpen: 'Available: voting open until {date}.',
    reasonSubmissionsOpen: 'Available: submissions open until {date}.',
    reasonActive: 'Available: the contest is active.',
    linkedProposal: 'Linked proposal',
    investment: 'Investment',
  },
  sponsordata: {
    title: 'Sponsor Data',
    sponsorInformation: 'Sponsor Information',
    sponsorName: 'Sponsor Name',
    industry: 'Industry',
    sponsorshipType: 'Sponsorship Type',
    financialInformation: 'Financial Information',
    rewardContribution: 'Reward Contribution',
    totalSponsorCost: 'Total Sponsorship Cost',
    contactInformation: 'Contact Information',
    email: 'Email',
    phone: 'Phone',
    website: 'Website',
    physicalTagsAssigned: 'Physical Tags Assigned',
    physicalTagsDescription: '(Physical Entry Tags - Contest entry physical tags)',
    viewTags: 'View Tags',
    loading: 'Loading...',
    tagsSponsor: 'Sponsor Tags:',
    tagsAmbassador: 'Ambassador Tags:',
    tier: 'Tier:',
    tagsReceived: 'Tags Received:',
    digitalPasses: 'Digital Passes:',
    unlimited: 'Unlimited',
    viewDigitalPasses: 'View Digital Passes',
    additionalNotes: 'Additional Notes',
    editSponsor: 'Edit Sponsor',
    errorOpeningForm: 'Error opening edit form',
  },
  voteboosterreport: {
    title: 'Vote Boosters Report',
    loadingStats: 'Loading statistics...',
    exportCSV: 'Export CSV',
    exporting: 'Exporting...',
    close: 'Close',
    totalRevenue: 'Total Revenue',
    totalPurchases: 'Total Purchases',
    uniqueBuyers: 'Unique Buyers',
    conversionRate: 'Conversion Rate',
    totalRevenueTooltip: 'Total amount of money generated from all vote booster purchases.',
    totalPurchasesTooltip: 'Total number of vote booster transactions completed.',
    uniqueBuyersTooltip: 'Number of different participants who have purchased vote boosters.',
    conversionRateTooltip: 'It is the percentage of participants who have purchased vote boosters.',
    revenueByTier: 'Revenue by Tier',
    revenueDistributionByTier: 'Revenue Distribution by Tier',
    purchasesDistributionByTier: 'Purchases Distribution by Tier',
    tier: 'Tier',
    quantity: 'Quantity',
    revenue: 'Revenue',
    totalVotes: 'Total Votes',
    averagePrice: 'Average Price',
    noPurchases: 'There are no vote booster purchases for this contest',
    topParticipantsByVotesBought: 'Top Participants by Votes Bought',
    participant: 'Participant',
    purchases: 'Purchases',
    totalSpent: 'Total Spent',
    noParticipantsWithPurchases: 'There are no participants with vote booster purchases',
    salesByDay: 'Sales by Day (Last 30 days)',
    dailySalesTrend: 'Daily Sales Trend (Revenue)',
    date: 'Date',
    votes: 'Votes',
    noSalesRecorded: 'No sales recorded',
    errorLoadingStats: 'Could not load vote booster statistics',
    reportTitle: 'Vote Boosters Report',
    contest: 'Contest',
    generationDate: 'Generation Date',
    generalStats: 'GENERAL STATISTICS',
    revenueByTierCSV: 'REVENUE BY TIER',
    tierCSV: 'Tier',
    quantityCSV: 'Quantity',
    totalRevenueCSV: 'Total Revenue',
    totalVotesCSV: 'Total Votes',
    averagePriceCSV: 'Average Price',
    salesByDayCSV: 'SALES BY DAY (LAST 30 DAYS)',
    dateCSV: 'Date',
    purchasesCSV: 'Purchases',
    revenueCSV: 'Revenue',
    votesTotalCSV: 'Total Votes',
    topParticipantsCSV: 'TOP PARTICIPANTS BY VOTES BOUGHT',
    participantCSV: 'Participant',
    votesTotalParticipantCSV: 'Total Votes',
    totalSpentCSV: 'Total Spent',
    errorExporting: 'Error exporting report',
  },
  tagstatistics: {
    title: 'Tag Statistics',
    loadingStats: 'Loading tag statistics...',
    close: 'Close',
    totalTags: 'Total Tags',
    tagsSold: 'Tags Sold',
    tagsAvailable: 'Tags Available',
    totalRevenue: 'Total Revenue',
    potentialRevenue: 'Potential Revenue',
    ambassadorsWithSales: 'Ambassadors with Sales',
    sponsorsWithTags: 'Sponsors with Tags',
    totalTagsTooltip: 'Total number of QR tags created for this contest.',
    tagsSoldTooltip: 'Number of tags that have been sold by ambassadors.',
    tagsAvailableTooltip: 'Number of tags that are still available for sale.',
    totalRevenueTooltip: 'Total revenue generated from tags sold by ambassadors.',
    potentialRevenueTooltip: 'Potential revenue if all available tags were sold at their full price.',
    ambassadorsWithSalesTooltip: 'Number of unique ambassadors who have sold at least one tag.',
    sponsorsWithTagsTooltip: 'Number of unique sponsors who have tags associated with this contest.',
    distributionBySponsorTier: 'Distribution by Sponsor Tier',
    tier: 'Tier',
    totalTagsHeader: 'Total Tags',
    tagsSoldHeader: 'Tags Sold',
    revenue: 'Revenue',
    distributionByType: 'Distribution by Type',
    type: 'Type',
    noStatsAvailable: 'No statistics available for this contest.',
    errorLoadingStats: 'Error loading tag statistics',
    searchPlaceholder: 'Search by Contest or Tag Code...',
  },
  invoicedata: {
    title: 'Invoice Data',
    loading: 'Loading invoice data...',
    noData: 'No invoice data available for this contest',
    close: 'Close',
    invoiceNumber: 'Invoice #',
    id: 'ID:',
    invoiceNumberLabel: 'Invoice Number:',
    contestId: 'Contest ID:',
    sponsorId: 'Sponsor ID:',
    invoiceDate: 'Invoice Date:',
    dueDate: 'Due Date:',
    subtotal: 'Subtotal:',
    tax: 'Tax:',
    total: 'Total:',
    status: 'Status:',
    paylink: 'Paylink:',
    createdAt: 'Created At:',
    updatedAt: 'Updated At:',
    items: 'Items:',
    activityLog: 'Activity Log:',
    description: 'Description:',
    quantity: 'Quantity:',
    unitPrice: 'Unit Price:',
    totalItem: 'Total:',
    date: 'Date:',
    action: 'Action:',
    errorLoading: 'Error loading invoice data for this contest',
    errorConnection: 'Connection error loading invoice data',
    errorGettingContest: 'Could not get the contest associated with this invoice',
    errorGettingContestGeneric: 'Error getting contest',
  },
  economyflow: {
    completeFlow: 'Complete Economic Flow',
    flowTitle: 'Sponsors → Ambassadors → Participants → Noah\'s Ark',
    sponsors: 'SPONSORS',
    noahsArk: 'NOAH\'S ARK',
    ambassadors: 'AMBASSADORS',
    participants: 'PARTICIPANTS',
    diagramTitle: 'Economic Flow Diagram',
    loading: 'Loading economic flow diagram...',
    close: 'Close',
    generalSummary: 'General Summary',
    totalContests: 'Total Contests',
    totalSponsors: 'Total Sponsors',
    totalAmbassadors: 'Total Ambassadors',
    totalParticipants: 'Total Participants',
    totalRevenue: 'Total Revenue',
    netProfit: 'Net Profit',
    flowSubtitle: 'Economic Flow: SPONSORS → NOAH\'S ARK → AMBASSADORS → PARTICIPANTS → NOAH\'S ARK',
    tagsSold: 'Tags Sold:',
    entries: 'Entries:',
    boosters: 'Boosters:',
    revenueTotal: 'Total Revenue:',
    threeValueLoops: 'The 3 Value Loops',
    totalInvestment: 'Total Investment',
    tagsSoldLabel: 'Tags Sold',
    voteBoosters: 'Vote Boosters',
    noDataAvailable: 'No data available for the economic flow diagram.',
    diagramButton: 'Economic Flow Diagram',
    loadingButton: 'Loading...',
    sponsorsDescription: 'Sponsors finance the contest',
    noahsArkReceivesFunding: 'Noah\'s Ark receives funding',
    ambassadorsDescription: 'Ambassadors sell physical tags',
    participantsDescription: 'Participants pay entries and buy boosters',
    noahsArkNetProfit: 'Net profit of Noah\'s Ark',
    voteBoostersLabel: 'Vote Boosters:',
    sponsorsLabel: 'Sponsors',
    ambassadorsLabel: 'Ambassadors',
    participantsLabel: 'Participants',
    noahsArkLabel: 'Noah\'s Ark',
    netProfitLabel: 'Net Profit',
    sponsorValueLoopTitle: '1. Sponsor Value Loop',
    sponsorValueLoopDescription: 'Sponsor → Receives exposure → Attracts pet owners → Generates goodwill → Sponsors again',
    totalSponsorsLabel: 'Total Sponsors',
    ambassadorProfitLoopTitle: '2. Ambassador Profit Loop',
    ambassadorProfitLoopDescription: 'Ambassador → Sells tags → Earns revenue → Gets motivated → Signs more sponsors',
    totalAmbassadorsLabel: 'Total Ambassadors',
    platformRevenueLoopTitle: '3. Platform Revenue Loop',
    platformRevenueLoopDescription: 'More entries → More boosters → More app downloads → Greater sponsor interest → More contests',
    totalContestsLabel: 'Total Contests',
    totalParticipantsLabel: 'Total Participants',
  },
  ambassadormanagement: {
    title: 'Ambassador Management',
    loading: 'Loading ambassadors...',
    close: 'Close',
    ambassadorReports: 'Ambassador Reports',
    updateAmbassadors: 'Update Ambassadors',
    updating: 'Updating...',
    inviteAmbassador: 'Invite Ambassador',
    searchPlaceholder: 'Search by name, email or phone...',
    name: 'Name',
    email: 'Email',
    phone: 'Phone',
    signedSponsors: 'Signed Sponsors',
    tagsSold: 'Tags Sold',
    revenue: 'Revenue',
    badges: 'Badges',
    actions: 'Actions',
    edit: 'Edit',
    viewTags: 'View Tags',
    viewCompensation: 'View Compensation',
    bonusManagement: 'Bonus Management',
    noAmbassadorsRegistered: 'No ambassadors registered',
    noAmbassadorsFound: 'No ambassadors found matching the search',
    recruiter: 'Recruiter',
    senior: 'Senior',
    elite: 'Elite',
    errorLoading: 'Error loading ambassadors',
    viewAssignments: 'View Contests',
    assignedContests: 'Assigned Contests',
    assignedContestsFor: 'Contests assigned to',
    noAssignments: 'This ambassador has no assigned contests.',
    sponsor: 'Sponsor',
    contest: 'Contest',
    tags: 'Tags',
    digitalPasses: 'Digital Passes',
    notificationStatus: 'Notification',
    notificationSent: 'Sent',
    notificationPending: 'Pending / no webhook',
    notificationFailed: 'Failed',
    assignedAt: 'Assigned',
    loadingAssignments: 'Loading assignments...',
    ambassadorNotifiedOnAssign: 'The ambassador was notified about the assignment.',
  },
  inviteambassador: {
    title: 'Invite Ambassador',
    emailLabel: 'Email Address',
    emailPlaceholder: 'example@email.com',
    description: 'An invitation email will be sent to the entered email address.',
    cancel: 'Cancel',
    send: 'Send Invitation',
    sending: 'Sending...',
  },
  editambassador: {
    title: 'Edit Ambassador',
    newTitle: 'New Ambassador',
    name: 'Name',
    email: 'Email',
    phone: 'Phone',
    status: 'Status',
    statusLabel: 'Status',
    active: 'Active',
    inactive: 'Inactive',
    cancel: 'Cancel',
    update: 'Update',
    create: 'Create',
    nameEmailRequired: 'Name and email are required',
  },
  ambassadortags: {
    title: 'Physical Tags Assigned to Ambassador',
    subtitle: '(Physical Entry Tags)',
    ambassador: 'Ambassador:',
    loading: 'Loading tags...',
    noTagsAssigned: 'No tags assigned to this ambassador yet.',
    totalTags: 'Total tags:',
    available: 'Available:',
    sold: 'Sold:',
    searchPlaceholder: 'Search by Tag Code, Contest or Sponsor...',
    tagCode: 'Tag Code',
    contest: 'Contest',
    sponsor: 'Sponsor',
    status: 'Status',
    type: 'Type',
    price: 'Price',
    assignmentDate: 'Assignment Date',
    saleDate: 'Sale Date',
    salePrice: 'Sale Price',
    physical: 'Physical',
    digital: 'Digital',
    availableStatus: 'Available',
    soldStatus: 'Sold',
    noTagsFound: 'No tags assigned',
    noTagsMatchingSearch: 'No tags found matching the search',
    close: 'Close',
    errorLoading: 'Error loading ambassador tags',
  },
  ambassadordigitalpasses: {
    title: 'Digital Passes',
    loading: 'Loading digital passes...',
    ambassador: 'Ambassador:',
    noPassesAssigned: 'This ambassador has no digital passes assigned.',
    totalDigitalPasses: 'Total Digital Passes',
    codesGenerated: 'Codes Generated',
    codesUsed: 'Codes Used',
    assignedPasses: 'Assigned Digital Passes',
    contest: 'Contest',
    name: 'Name',
    type: 'Type',
    codesGeneratedHeader: 'Codes Generated',
    codesUsedHeader: 'Codes Used',
    availableCodes: 'Available Codes',
    creationDate: 'Creation Date',
    unlimited: 'Unlimited',
    limited: 'Limited',
    close: 'Close',
    errorLoading: 'Error loading ambassador digital passes',
  },
  bonusmanagement: {
    title: 'Referral Bonus Management',
    loading: 'Loading information...',
    ambassadorInfo: 'Ambassador Information',
    email: 'Email:',
    signedSponsors: 'Signed Sponsors:',
    bonusTagsReceived: 'Bonus Tags Received:',
    recruiterBadge: 'Recruiter Badge',
    seniorBadge: 'Senior Badge',
    eliteBadge: 'Elite Badge',
    signedSponsorsTooltip: 'Total number of sponsors signed by this ambassador. This counter determines the milestones for badges (Recruiter: 5, Senior: 10, Elite: 20).',
    bonusTagsReceivedTooltip: 'Physical entry tags awarded as rewards along with badges. These are additional tags beyond the regular sponsor tags.',
    recruiterBadgeTooltip: 'Awarded when the ambassador signs 5 sponsors. Includes 20 bonus tags and the "Ambassador Recruiter" badge for social media.',
    seniorBadgeTooltip: 'Awarded when the ambassador signs 10 sponsors. Includes 50 bonus tags, "Senior Ambassador Badge", and priority access to future contests.',
    eliteBadgeTooltip: 'Awarded when the ambassador signs 20 sponsors. Includes a custom tag, VIP recognition on Noah\'s Ark website, and invitations to special events.',
    grantBonusTagsTooltip: 'Bonus tags are physical entry tags awarded as rewards. They are created automatically and assigned to the ambassador.',
    tagsQuantityTooltip: 'Number of bonus tags to grant to the ambassador. Tags will be created automatically with unique codes.',
    assignBadgesManually: 'Assign Badges Manually',
    assignRecruiter: 'Assign Recruiter',
    assignSenior: 'Assign Senior',
    assignElite: 'Assign Elite',
    recruiterAssigned: '✓ Recruiter',
    seniorAssigned: '✓ Senior',
    eliteAssigned: '✓ Elite',
    grantBonusTags: 'Grant Bonus Tags',
    tagsQuantity: 'Tags Quantity',
    grantTags: 'Grant Tags',
    granting: 'Granting...',
    grantTagsHelper: 'Tags will be created automatically and assigned to the ambassador',
    bonusHistory: 'Granted Bonus History',
    noHistory: 'No bonus history for this ambassador.',
    date: 'Date',
    type: 'Type',
    quantity: 'Quantity',
    description: 'Description',
    status: 'Status',
    badge: 'Badge',
    bonusTags: 'Bonus Tags',
    customTag: ' + Custom Tag',
    close: 'Close',
  },
  forms: {
    createContest: 'Create New Contest',
    createContestSubtitle: 'Complete the steps to configure your contest',
    editContest: 'Edit Contest',
    editContestSubtitle: 'Update your contest configuration',
  },
  stepsContestForm: {
    basic: 'Basic',
    prizes: 'Prizes',
    dates: 'Dates',
    media: 'Media',
    eligibility: 'Eligibility',
    advanced: 'Advanced',
  },
  basicinfo: {
    name: 'Name',
    description: 'Description',
    theme_name: 'Theme Name',
    theme_keywords: 'Theme Keywords',
    entrance_fee: 'Entrance Fee',
    min_participants: 'Minimum Participants',
    members_only: 'Members Only',
    subscribers_only: 'Subscribers Only',
    members_only_description: 'Only members',
    subscribers_only_description: 'Only subscribers',
    basicinfo: 'Basic Information',
    basicinfo_subtitle: 'Complete the steps to configure your contest',
    name_placeholder: 'Enter the name of the contest',
    description_placeholder: 'Enter the description of the contest',
    theme_name_placeholder: 'Enter the name of the theme',
    theme_keywords_placeholder: 'Enter the keywords of the theme',
    prices_configuration: 'Prices Configuration',
    organizer_buy_rate: 'Organizer Buy Rate',
    access_restrictions: 'Access Restrictions',
    seasonal_theme: 'Seasonal Theme',
    Ticket_based_only: 'Ticket Based Only',
    Ticket_based_only_description: 'Only participants with a valid ticket',
    name_required: 'Name is required',
    description_required: 'Description is required',
    entrance_fee_positive: 'Entrance fee must be positive',
    min_participants_required: 'Minimum 1 participant',
    max_participants_required: 'Set the maximum number of participants that can join the contest. Must be greater than or equal to the minimum number of participants.',
    max_participants: 'Maximum Participants',
  },
  prizesinfo: {
    main_prize: 'Grand Prize',
    grand_prize: 'Grand Prize',
    grand_prize_description: 'Total Grand Prize amount. For reference only: you set each place amount manually below.',
    grand_prize_distribution: 'Grand Prize Distribution',
    grand_prize_distribution_hint: 'Reference percentages when editing the Grand Prize. You can adjust each place manually.',
    sponsor_reward_applied: 'Sponsor reward contribution applied to Grand Prize',
    secondary_prize_pool: 'Secondary prize pool',
    total_prize_pool_breakdown: 'Total prize pool summary',
    percent_of_grand_prize: 'of Grand Prize',
    secondary_prize: 'Secondary Prize',
    secondary_prize_explanation: 'Choose how many secondary winners there will be. The total is split into bands (High, Medium, Low and Minimum) based on a share of places, and you can adjust each amount within its band range.',
    secondary_prize_auto: 'The total is automatically split across secondary places using bands. Each place stays within its band range and you can adjust it manually.',
    secondary_prize_range: 'Valid range for {places} places: {min} – {max}. Amounts below {max} show decreasing prizes from #1 downward.',
    secondary_band_alta: 'High',
    secondary_band_media: 'Medium',
    secondary_band_baja: 'Low',
    secondary_band_minima: 'Minimum',
    secondary_below_min: 'With {places} secondary places the minimum distributable amount is {min}. Raise the secondary prize to {suggested} so it fits.',
    secondary_above_max: 'You entered more than the maximum ({max}). The prizes below show each band at its cap (all at maximum). To see decreasing amounts, lower Secondary Prize — try {example}.',
    secondary_assigned_less_than_entered: 'Only {assigned} was assigned from what you entered. With {places} places the max is {max}. Try {example} to see prizes decrease from #1 downward.',
    secondary_apply_suggested: 'Use {amount}',
    number_of_places: 'Number of Places',
    number_of_places_helper: 'Select the number of prize places (minimum 1)',
    grand_prize_places_label: 'Number of Grand Prize places',
    grand_prize_places_helper: 'How many main winners (1 to 4). Fill in each place amount manually.',
    secondary_prize_places_label: 'Number of secondary places',
    secondary_prize_places_helper: 'How many secondary winners. Places are split into bands: High 5%, Medium 40%, Low 45%, Minimum 10%.',
    grand_prize_total: 'Grand Prize Total',
    secondary_prize_total: 'Secondary Prize Total',
    grand_prize_assigned: 'Assigned to places',
    secondary_prize_assigned: 'Assigned to places',
    prize_first_place: '1st Place',
    prize_second_place: '2nd Place',
    prize_third_place: '3rd Place',
    prize_fourth_place: '4th Place',
    place_first: '1st',
    place_second: '2nd',
    place_third: '3rd',
    place_fourth: '4th',
    prizes_structure: 'Prizes Structure',
    prize_type: 'Prize Type',
    cash: 'Cash',
    gift_card: 'Gift Card',
    vouchers: 'Vouchers',
    mixed: 'Mixed',
    total_prize_pool: 'Total Prize Pool',
    main_prize_warning: 'Grand Prize must be greater than the secondary prize',
    main_prize_placeholder: 'e.g. 250.00',
    secondary_prize_placeholder: 'e.g. 10.00',
    
  },
  datesinfo: {
    submission_start: 'Submission Start',
    submission_deadline: 'Submission Deadline',
    voting_start: 'Voting Start',
    voting_end: 'Voting End',
    winner_announcement: 'Winner Announcement',
    contest_schedule: 'Contest Schedule',
    submission_start_required: 'Submission Start Required',
    submission_deadline_required: 'Submission Deadline Required',
    winner_announcement_required: 'Winner Announcement Required',
  },
  mediainfo: {
    allowed_media_types: 'Allowed Media Types',
    max_images: 'Max Images',
    max_videos: 'Max Videos',
    max_image_size_mb: 'Max Image Size (MB)',
    max_video_size_mb: 'Max Video Size (MB)',
    max_video_duration_seconds: 'Max Video Duration (Seconds)',
    photo_rewards: 'Photo Rewards',
    media_requirements: 'Media Requirements',
    only_images: 'Only Images',
    only_videos: 'Only Videos',
    images_and_videos: 'Images and Videos',
    images_configuration: 'Images Configuration',
    videos_configuration: 'Videos Configuration',
    photo_rewards_mode: 'Photo Rewards Mode',
    photo_rewards_user_percentage: 'Photo Rewards User Percentage',
    photo_rewards_organizer_percentage: 'Photo Rewards Organizer Percentage',
    photo_rewards_noahs_ark_percentage: 'Photo Rewards Noah\'s Ark Percentage',
    disabled: 'Disabled',
    optional: 'Optional',
    required: 'Required',
    one_media_per_entry: '1 media file per entry',
    one_media_per_entry_both: 'Each participant may submit 1 image or 1 video (not both).',
    one_image_per_entry: 'Each participant may submit exactly 1 image.',
    one_video_per_entry: 'Each participant may submit exactly 1 video.',
    fixed_one_per_entry: 'Fixed: 1 per entry',
    standard_image_preset: 'Recommended standard: {width}×{height}px ({ratio}) · max {size} MB · JPG, JPEG, PNG, WEBP',
    standard_video_preset: 'Recommended standard: {width}×{height}px ({ratio}) · max {size} MB · max {duration}s · MP4, MOV',
    allowed_formats: 'Allowed formats',
    allowed_formats_hint: 'Select the file formats accepted for this contest.',
    allowed_formats_required: 'Select at least one allowed format for the chosen media type.',
  },
  eligibilityinfo: {
    allowed_countries: 'Allowed Countries',
    allowed_pet_types: 'Allowed Pet Types',
    age_group: 'Age Group',
    min_age: 'Minimum Age',
    max_age: 'Maximum Age',
    requires_guardian_consent: 'Requires Guardian Consent',
    education_type: 'Education Type',
    institution_name: 'Institution Name',
    academic_subject: 'Academic Subject',
    requires_institution_verification: 'Requires Institution Verification',
    photo_rewards_mode: 'Photo Rewards Mode',
    photo_rewards_user_percentage: 'Photo Rewards User Percentage',
    photo_rewards_organizer_percentage: 'Photo Rewards Organizer Percentage',
    photo_rewards_noahs_ark_percentage: 'Photo Rewards Noah\'s Ark Percentage',
    all_countries: 'All Countries',
    all_countries_description: 'Includes all {count} countries and territories available on the platform.',
    countries_selected_count: '{count} countries/territories selected',
    allowed_countries_required: 'Select at least one country or territory.',
    region_north_america: 'North America',
    region_central_america: 'Central America',
    region_caribbean: 'Caribbean',
    region_south_america: 'South America',
    region_europe: 'Europe',
    region_asia_pacific: 'Asia-Pacific',
    es: 'Spain',
    mx: 'Mexico',
    ar: 'Argentina',
    sr: 'Surinam',
    in: 'India',
    co: 'Colombia',
    us: 'United States',
    ca: 'Canada',
    pe: 'Peru',
    ec: 'Ecuador',
    cr: 'Costa Rica',
    pa: 'Panama',
    jm: 'Jamaica',
    au: 'Australia',
    gt: 'Guatemala',
    hn: 'Honduras',
    sv: 'El Salvador',
    ni: 'Nicaragua',
    do: 'Dominican Republic',
    pr: 'Puerto Rico',
    ve: 'Venezuela',
    cl: 'Chile',
    uy: 'Uruguay',
    py: 'Paraguay',
    bo: 'Bolivia',
    br: 'Brazil',
    pt: 'Portugal',
    fr: 'France',
    de: 'Germany',
    gb: 'United Kingdom',
    it: 'Italy',
    nl: 'Netherlands',
    nz: 'New Zealand',
    jp: 'Japan',
    ph: 'Philippines',
    sg: 'Singapore',
    all: 'All',
    eligibility_criteria: 'Eligibility Criteria',
    eligibility_criteria_description: 'Define who can participate in the contest. You can restrict access by country, pet type, age group, or educational requirements.',
    dog: 'Dog',
    cat: 'Cat',
    horse: 'Horse',
    pony: 'Pony',
    rabbit: 'Rabbit',
    guinea_pig: 'Guinea Pig',
    hamster: 'Hamster',
    ferret: 'Ferret',
    chinchilla: 'Chinchilla',
    rat: 'Rat',
    mouse: 'Mouse',
    hedgehog: 'Hedgehog',
    bird: 'Bird',
    parrot: 'Parrot',
    chicken: 'Chicken',
    duck: 'Duck',
    turtle: 'Turtle',
    snake: 'Snake',
    lizard: 'Lizard',
    fish: 'Fish',
    goat: 'Goat',
    sheep: 'Sheep',
    pig: 'Pig',
    cow: 'Cow',
    other: 'Other Pet',
    all_pet_types: 'All Pet Types',
    all_pet_types_description: 'Includes all {count} pet categories available on the platform.',
    pet_types_selected_count: '{count} categories selected',
    allowed_pet_types_required: 'Select at least one pet category.',
    pet_group_companion: 'Companion',
    pet_group_equine: 'Equine',
    pet_group_small_mammals: 'Small Mammals',
    pet_group_birds: 'Birds',
    pet_group_reptiles: 'Reptiles',
    pet_group_aquatic: 'Aquatic',
    pet_group_farm: 'Farm',
    pet_group_other: 'Other',
    additional_eligibility: 'Additional eligibility parameters',
    additional_eligibility_description: 'Optional participant restrictions by age and guardian consent.',
    guardian_consent_required: 'Requires guardian/parent consent',
    guardian_consent_helper: 'Required for contests with underage participants.',
    min_age_helper: 'Minimum participant age (optional).',
    max_age_helper: 'Maximum participant age (optional).',
    custom_age_range: 'Custom age range',
    max_age_must_be_greater: 'Maximum age must be greater than or equal to minimum age.',
    education_eligibility: 'Education eligibility',
    institution_name: 'Institution',
    academic_subject: 'Subject / Academic program',
    all_ages: 'All Ages',
    under_18: 'Under 18',
    over_18: 'Over 18',
  },
  advancedinfo: {
    sponsorship_type: 'Sponsorship Type',
    advanced_settings: 'Advanced Settings',
    advanced_settings_description: 'Additional settings to customize the contest according to your specific needs. Select if the contest will be exclusively held in an educational institution and the type of sponsorship it will have. If it does not apply to your contest, you can leave these fields blank.',
    none: 'No',
    education_type: 'Education Type',
    elementary_school: 'Elementary School',
    high_school: 'High School',
    college_university: 'College/University',
    summary: 'Summary',
    name: 'Name',
    entrance_fee: 'Entrance Fee',
    prizes: 'Prizes',
    sponsored: 'Sponsored',
    none_sponsorship: 'No sponsorship',
    vote_type: 'Vote Type',
    vote_type_users: 'Users',
    vote_type_judges: 'Judges',
    size_vote: 'Vote Weight',
    size_vote_helper: 'Define the weight that each judge vote will have (example: 1.0 = normal vote, 2.0 = double weight)',
  },
  couponpassesinfo: {
    coupon_passes: 'Coupon Passes',
    coupon_passes_description: 'Coupon passes are a way to allow participants to purchase entries to the contest using a coupon code. You can enable or disable this system and define the corresponding prizes.',
    enable_coupon_passes: 'Enable Coupon Passes',
    disabled: 'Disabled',
    enabled: 'Enabled',
    number_of_uses_per_coupon: 'Number of Uses per Coupon',
    number_of_coupons_to_generate: 'Number of Coupons to Generate',
    number_of_coupons_to_generate_description: 'Number of unique coupons to generate for this contest',
    integration_with_petflix_qr_tags: 'Integration with Petflix QR TAGS',
    no_integration_with_qr_tags: 'No Integration with QR TAGS',
    integrate_with_petflix_qr_tags: 'Integrate with Petflix QR TAGS',
    add_qr_to_existing_coupon_passes: 'Add QR Tags to Existing Coupon Passes',
    select_shelter: 'Select shelter',
    individual_qr: 'Individual QR',
    individual_qr_description: 'When enabled, individual QR tags will be generated for each coupon pass',
    create_new_qr_tags: 'Create New Qr Tags',
    use_existing_codes: 'Use existing QR tags',
    list_of_coupon_passes: 'List of Coupon Passes',
  },
  contestformbuttons: {
    previous: 'Previous',
    next: 'Next',
    create: 'Create Contest',
  },
  contestformdraft: {
    restore_title: 'Restore draft?',
    restore_message: 'There is a saved draft of an unfinished contest. Do you want to continue where you left off?',
    restore_confirm: 'Restore draft',
    restore_discard: 'Start fresh',
    close_title: 'Leave the form?',
    close_message: 'You have unsaved changes. You can save a draft to continue later.',
    close_save: 'Save draft and leave',
    close_discard: 'Leave without saving',
    close_cancel: 'Cancel',
    beforeunload: 'You have unsaved changes in the contest form.',
  },
  Tooltips_explications: {
    eligibility_criteria: 'Define who can participate in the contest. You can restrict access only to registered members, premium subscribers, or allow anyone to join.',
    prices_configuration: 'Entry fee that participants must pay to join the contest. This amount is charged to each participant when they register.',
    organizer_buy_rate: 'Special purchase rate for the contest organizer. This discount is applied when the organizer purchases entries or additional services.',
    min_participants: 'Minimum number of participants required for the contest to be active. If this number is not reached, the contest may be cancelled or postponed.',
    photo_rewards_mode: 'Configure the rewards that participants will receive for uploading photos to the contest. You can enable or disable this system and define the corresponding prizes.',
    photo_rewards_user_percentage: 'Percentage of rewards that participants will receive for each photo uploaded to the contest.',
    photo_rewards_organizer_percentage: 'Percentage of rewards that the contest organizer will receive for each photo uploaded to the contest.',
    photo_rewards_noahs_ark_percentage: 'Percentage of rewards that Noah\'s Ark will receive for each photo uploaded to the contest.',
    prizes_structure: 'Configure the prizes structure for your contest. Define how many places there will be, the prizes for each position, and whether you will include main prizes or secondary prizes. The secondary winners will always win less than the withdrawal limit to obtain a gift card (minimum $5 USD to withdraw profits).',
    media_requirements: 'Define the types of multimedia files that participants can upload to the contest. You can allow photos, videos, or both, and set size and format restrictions.',
    theme_name: 'Name of the theme or category of the contest. This name helps identify and organize the type of content that participants must submit (e.g., Spring, Halloween, Christmas).',
    theme_keywords: 'Keywords related to the contest theme. These words help categorize and improve contest searchability. You can add multiple keywords separated.',
    submission_start: 'Date and time when participants can start submitting their entries to the contest. This marks the beginning of the submission period.',
    submission_deadline: 'Date and time when the submission period ends. After this date, no new entries will be accepted.',
    voting_start: 'Date and time when voting begins. Participants and users can start casting votes for their favorite entries.',
    voting_end: 'Date and time when voting ends. After this date, no more votes will be accepted.',
    winner_announcement: 'Date and time when the contest winners will be announced. This is when the results are made public.',
    integration_with_petflix_qr_tags: 'Select whether you want to integrate coupon passes with Petflix QR tags. You can choose not to integrate, integrate with new QR tags, or add QR tags to existing coupon passes.',
    select_shelter: 'Select the shelter associated with the QR tags that will be generated or used for the coupon passes.',
    tag_type: 'Type of tag to be used for the QR tags. Each type has different characteristics and purposes within the system.',
    individual_qr: 'When enabled, individual QR tags will be generated for each coupon pass, allowing unique tracking of each code.',
    create_new_qr_tags: 'Create new QR tags for coupon passes. This option generates new tags that will be linked with coupon codes.',
    use_existing_codes: 'Use existing QR tags in the system. This option allows linking coupon passes with tags that were previously created.',
    list_of_coupon_passes: 'List of coupon pass codes generated for this contest. These codes can be used by participants to enter the contest at no cost.',
  },

  create_sponsorship_form: {
    how_do_you_want_to_proceed: 'How do you want to proceed?',
    new_sponsor: 'New Sponsor',
    select_sponsor: 'Select Sponsor',
    create_sponsorship: 'Create Sponsorship',
    how_do_you_want_to_proceed_description: 'Choose how you want to proceed to create a sponsorship',
    new_sponsor_description: 'Create a new sponsor',
    select_sponsor_description: 'Select an existing sponsor',
    search_sponsor: 'Search sponsor...',
    create_sponsorship_description: 'Define the type, budget, assets and calendar of the sponsorship',
    contest_already_has_sponsor: 'The contest already has a sponsor',
    contest_already_has_sponsor_assigned: 'The contest {contestName} already has a sponsor assigned:',
    replace_existing_sponsor_question: 'Do you want to replace the existing sponsor with the new sponsor?',
  },
  stepsSponsorshipForm: {
    basic: 'Basic',
    type_and_budget: 'Type and Budget',
    assets_and_visibility: 'Assets and Visibility',
    dates_and_summary: 'Dates and Summary',
  },
  basicinfosponsorship: {
    sponsor_information: 'Sponsor Information',
    sponsor_name: 'Sponsor Name',
    sponsor_short_name: 'Sponsor Short Name',
    industry: 'Industry',
    contact_name: 'Contact Name',
    contact_email: 'Contact Email',
    sponsor_name_required: 'Sponsor name is required',
  },
  type_and_budget_info_sponsorship: {
    tiers: 'Tiers',
    optional: '(Optional)',
    tiersTooltip: 'Select a tier to automatically assign physical tags and digital passes to the sponsor and their ambassador. Tiers determine the number of tags that will be automatically assigned.',
    sponsorTagTiers: 'Sponsor Tag Tiers',
    sponsorTagTiersHelper: 'Select a tier to automatically assign physical tags and digital passes to the sponsor and their ambassador.',
    none: 'None',
    goldTier: 'Gold ($1,500) - 50 sponsor tags + 100 ambassador tags',
    silverTier: 'Silver ($1,000) - 30 sponsor tags + 50 ambassador tags',
    bronzeTier: 'Bronze ($500) - 12 sponsor tags + 20 ambassador tags',
    assignedAmbassador: 'Assigned Ambassador (Optional)',
    searchAmbassadorPlaceholder: 'Search ambassador by name or email...',
    assignedAmbassadorHelper: 'Select an ambassador who signed this sponsor to assign them additional tags.',
    noAmbassadorsFound: 'No ambassadors found matching the search',
    loadingAmbassadors: 'Loading ambassadors...',
    type_and_budget: 'Type and Budget',
    type_and_budget_description: 'Select the type of sponsorship and the budget for your contest',
    rewards_only: 'Reward Prize Only',
    full_entrance: 'Full Entrance (100%)',
    partial_entrance: 'Partial Entrance',
    branding_only: 'Premium Branding Package',
    custom: 'Complete',
    entrance_type: 'Entrance Type',
    entrance_type_description: 'Select whether the sponsorship covers the entrance completely or partially',
    entrance_type_tooltip: 'Select whether the sponsorship covers the entrance completely (100%) or partially (custom percentage). This determines how much of the entry fees will be covered by the sponsor.',
    reward_contribution: 'Reward Contribution',
    reward_contribution_tooltip: 'Amount of money that the sponsor contributes to the prize pool. This is the base amount that will be distributed among the winners.',
    total_cost: 'Total Cost',
    total_cost_tooltip: 'Total cost of the sponsorship. This is automatically calculated as the sum of Reward Contribution plus the selected Tier value (if any).',
    impressions_meta: 'Impressions Meta',
    impressions_meta_tooltip: 'Target number of impressions (views) that the sponsorship should achieve. This is a goal metric for measuring the reach of the sponsorship.',
    engagements_meta: 'Engagements Meta',
    engagements_meta_tooltip: 'Target number of engagements (likes, comments, shares) that the sponsorship should achieve. This is a goal metric for measuring audience interaction.',
    quick_summary: 'Quick Summary',
    platform_configuration: 'Platform Configuration',
    platform_configuration_description: 'Select the platforms where the sponsorship will be displayed',
    apply_default_platforms: 'Apply Default Platforms',
    platforms_auto_configured: 'Default platforms have been automatically configured for this sponsorship type. You can modify them manually.',
    platform_enabled: 'Enabled',
    platform_disabled: 'Disabled',
    active_platforms_count: 'active platform(s)',
  },
  assets_and_visibility_info_sponsorship: {
    assets_and_visibility: 'Assets and Visibility',
    assets_and_visibility_description: 'Select the assets and visibility for your sponsorship',
    logo_url: 'Logo URL',
    banner_url: 'Banner URL',
    brand_guidelines_url: 'Brand Guidelines URL',
    landing_url: 'Landing URL',
    slogan: 'Slogan',
    website_url: 'Website URL',
    brand_assets: 'Brand Assets',
    social_links: 'Social Links',
    notes: 'Notes',
  },
  dates_and_summary_info_sponsorship: {
    dates_and_summary: 'Dates and Summary',
    dates_and_summary_description: 'Select the dates and summary for your sponsorship',
    start_date: 'Start Date',
    end_date: 'End Date',
    total_cost: 'Total Cost',
    sponsor: 'Sponsor',
    no_contact: 'No Contact',
    type_and_meta: 'Type and Meta',
    rewards: 'Rewards',
    entrace_coverage: 'Entrance Coverage',
  },
  preview_modal_info_sponsorship: {
    downloadImages: 'Download Contest Information',
    downloadAllPlatformsWord: 'Download All Platforms (Word)',
    preview: 'Preview',
    platform: 'Platform',
    available: 'Available',
    description: 'Description',
    facebook_description: 'Facebook Description',
    instagram_description: 'Instagram Description',
    voletaje_description: 'Flyer Description',
    yes: 'Yes',
    no: 'No',
    rewards_only_description: 'This type of sponsorship includes visibility on Facebook and Instagram.',
    branding_only_description: 'This type of sponsorship includes visibility on Facebook, Instagram and flyer.',
    voletaje: 'Flyer',
    close: 'Close',
    previewButton: 'Preview',
    facebook: 'Facebook',
    instagram: 'Instagram',
    preview1: 'Preview 1',
    preview2: 'Preview 2',
    preview3: 'Preview 3',
    customPlatform: 'Custom Platform',
    customPlatformDescription: 'Custom adjustable flyer',
    basePlatformDescription: 'Base platform with positionable flyer',
    adjustPreview: 'Adjust Preview',
    viewPreview: 'View Preview',
    addPlatform: 'Add Platform',
    configurePreviews: 'Configure Visible Previews',
    selectPreviewsDescription: 'Select which previews you want to show in the previews table:',
    restoreDefault: 'Restore Default',
    previewVoletajeAd: 'Preview - Flyer Ad',
    previewInstagram: 'Preview Instagram',
    previewInstagramFlyer: 'Preview Instagram - Flyer',
    previewInstagramBigFlyer: 'Preview Instagram - Big Flyer',
    previewFacebook: 'Preview Facebook',
    previewVoletajeSmall: 'Preview Flyer Small',
    addNewPlatform: 'Add New Platform',
    uploadMainImage: 'Upload Main Image',
    adjustFlyerPreview: 'Adjust Flyer Preview',
    clickToUpload: 'Click to upload an image',
    imageFormats: 'PNG, JPG, GIF up to 10MB',
    uploadedImage: 'Uploaded image',
    mainImage: 'Main image',
    placeholder: 'Placeholder',
    sponsorshipType: 'Sponsorship Type:',
    rewardsOnly: 'Rewards Only',
    branding: 'Branding',
    yourAdGoesHere: 'YOUR AD GOES HERE',
    availableInAppleStore: 'Available in Apple Store only',
    adjustSettings: 'Adjust Settings',
    delete: 'Delete',
    deleteConfirm: 'Are you sure you want to delete this platform?',
    changeVoletoSize: 'Change Flyer Size',
    width: 'Width (px)',
    height: 'Height (px)',
    distanceX: 'Distance X (px)',
    distanceXHelper: 'Distance between components and the top of the flyer',
    generalImageSize: 'General Image Size',
    generalImageWidth: 'General Image Width (px)',
    generalImageWidthHelper: 'Total width of the image (background + flyer). Height adjusts automatically.',
    generalImageHeight: 'General Image Height (px)',
    generalImageHeightHelper: 'Total height of the image (background + flyer). Width adjusts automatically.',
    continue: 'Continue',
  },
  details_contest: {
    economic_performance: 'Economic Performance',
    total_revenue: 'Total Revenue',
    total_costs: 'Total Costs',
    net_profit: 'Net Profit',
    roi: 'ROI',
    participant: 'Participant',
    Prizes: 'Prizes',
    Main_Prize: 'Grand Prize',
    Grand_Prize: 'Grand Prize',
    Reward_Contribution: 'Reward Contribution',
    Secondary_Prize: 'Secondary Prize',
    Ops: 'Ops',
    Margin: 'Margin',
    Per_Participant: 'Per Participant',
    Photo_Rewards_User_Percentage: 'User Percentage',
    Photo_Rewards_Organizer_Percentage: 'Organizer Percentage',
    Photo_Rewards_Noahs_Ark_Percentage: 'Noah\'s Ark Percentage',
    Media_Requirements: 'Media Requirements',
    Eligibility_Criteria: 'Eligibility Criteria',
    Allowed_Countries: 'Allowed Countries',
    Allowed_Pet_Types: 'Allowed Pet Types',
    Allowed_Age_Group: 'Age Group',
    MembershipAndPaymentBreakdown : "Entry Management",
    ContentAccess: "Content Access",
    BasePrice: "Base Price",
    OpenToAll: "Open to All",
    Pays: "Pays",
    Discounts: "Discounts",
    Revenue: "Revenue",
    Totla_Participants: "Total Participants",
    Actual_Revenue: "Actual Revenue",
    Potential_Revenue: "Potential Revenue",
    Total_Discounts: "Total Discounts",
    Avg_Per_Participant: "Avg Per Participant",
    Revenue_Efficiency: "Revenue Efficiency",
    ContestConfiguration: "Contest Configuration",
    Status: "Status",
    Phase: "Phase",
    AccessLevel: "Access Level",
    PhotoRewardsMode: "Photo Rewards Mode",
    PrizeType: "Prize Type",
    RevenueAnalysis: "Revenue Analysis",
    FullPriceRevenue: "Full Price Revenue",
    DiscountedRevenue: "Discounted Revenue",
    VoucherValueUsed: "Voucher Value Used",
    TotalDiscountsGiven: "Total Discounts Given",
    RevenueEfficiency: "Revenue Efficiency",
    PotentialRevenue: "Potential Revenue",
    PrizeandSponsorship: "Prize and Sponsorship",
    PrizePoolBreakdown : "Prize Pool Breakdown",
    Frist_Place: "1st Place",
    Second_Place: "2nd Place",
    Third_Place: "3rd Place",
    Fourth_Place: "4th Place",
    PhotoRewardsSplit: "Photo Rewards Split",
    User_Percentage: "User",
    Organizer_Percentage: "Organizer",
    NoahsArk_Percentage: "Noah's Ark",
    simulateParticipant: "Simulate Participant",
    ScheduleandTimeline: "Schedule and Timeline",
    SubmissionPeriod: "Submission Period",
    WinnerAnnouncement: "Winner Announcement",
    MediaRequirements: "Media Requirements",
    Allowed_Types: "Allowed Types",
    Max_Images: "Max Images",
    Max_Videos: "Max Videos",
    Imagesize_limit: "Image Size Limit",
    Videosize_limit: "Video Size Limit",
    Video_duration: "Video Duration",
    ParticipationProgress: "Participation Progress",
    Current_Progress: "Current Progress",
    participants: "participants",
    Need: "Need",
    downloadData: "Download Data",
    downloadPlatforms: "Download Platforms",
    VotingPeriod: "Voting Period",
    more: "more participants",
    Sponsorship_Details: "Sponsorship Details",
    type: "Type",
    contribution: "Contribution",
    impressions: "Impressions",
    engagements: "Engagements",
    Sponsor: "Sponsor",
    
  },
  participantmodal: {
    addParticipant: "Add Participant",
    participationType: "Participation Type",
    paidParticipant: "Paid Participant",
    couponPass: "CouponPass (Free with code)",
    cancel: "Cancel",
    createParticipant: "Create Participant",
    creating: "Creating...",
    close: "Close",
    enteredContest: "You entered the contest!",
    passCode: "Pass code:",
    contestFull: "Contest full",
    contestFullMessage: "Sorry, there are no available passes for this contest at this time.",
    couponCode: "Coupon Code",
    enterCode: "Enter the code",
    validating: "Validating...",
    validate: "Validate",
    validCode: "✓ Valid code - Remaining uses:",
    pleaseEnterCode: "Please enter a coupon code",
    numberOfParticipants: "Number of Participants",
    errorValidatingCode: "Error validating code",
    errorCreatingParticipant: "Error creating participant",
    Inactive: "Inactive",
  },
  contestparticipants: {
    title: "Contest Participants",
    noParticipants: "No participants registered for this contest yet.",
    votes: "votes",
    like: "Like",
    endContest: "End Contest",
    winnersTitle: "Contest Winners",
    noWinners: "No winners registered for this contest.",
    firstPlace: "1st Place",
    secondPlace: "2nd Place",
    thirdPlace: "3rd Place",
    fourthPlace: "4th Place",
    place: "Place",
    generalStats: "General Statistics",
    totalParticipants: "Total Participants",
    totalVotes: "Total Votes",
    averageVotes: "Average Votes",
    participantsByEntryType: "Participants by Entry Type",
    conversionToBoosters: "Conversion to Booster Buyers",
    boosterBuyers: "Booster Buyers",
    conversionRate: "Conversion Rate",
    totalParticipantsTooltip: "Total number of participants registered in the contest.",
    boosterBuyersTooltip: "Number of participants who have purchased vote boosters.",
    conversionRateTooltip: "Percentage of participants who have purchased vote boosters.",
    top10MostVoted: "Top 10 Most Voted",
    rank: "#",
    name: "Name",
    votesHeader: "Votes",
    votesPerDay: "Votes per Day",
    buyVotes: "Buy Votes",
  },
  platforms: {
    managePlatforms: 'Manage Base Platforms',
    addPlatform: 'Add Platform',
    editPlatform: 'Edit Platform',
    name: 'Name',
    status: 'Status',
    actions: 'Actions',
    enabled: 'Enabled',
    disabled: 'Disabled',
    viewPreview: 'View Preview',
    thumbnail: 'Thumbnail',
    edit: 'Edit',
    delete: 'Delete',
    cancel: 'Cancel',
    save: 'Save',
    preview: 'Preview',
    uploadImage: 'Upload Image',
    selectFile: 'Select file',
    noFileSelected: 'No file selected',
    position: 'Position',
    width: 'Width',
    height: 'Height',
    size: 'Size',
    manual: 'Manual',
    applySize: 'Apply Size',
    logoImageUrl: 'Logo Image URL',
    shape: 'Shape',
    circular: 'Circular',
    square: 'Square',
    contestText: 'Contest Name (static)',
    contestName: 'Contest Name',
    customText: 'Custom Text',
    logoWidth: 'Logo Width',
    logoHeight: 'Logo Height',
    logoSize: 'Logo Size',
    fontSize: 'Font Size',
    previewScale: 'Preview Scale',
    apply: 'Apply',
    flyerArea: 'Flyer Area',
    noImage: 'No image available',
    loading: 'Loading...',
    noPlatforms: 'No platforms available',
    confirmDelete: 'Are you sure you want to delete this platform?',
    errorDeleting: 'Error deleting platform',
    errorSaving: 'Error saving platform',
    nameAndImageRequired: 'Name and image are required',
    configureSponsorshipTypes: 'Configure Sponsorship Types',
    sponsorshipTypes: 'Sponsorship Types',
    addSponsorshipType: 'Add Type',
    typeName: 'Type Name',
    selectPlatforms: 'Select Platforms',
    platformFacebook: 'Facebook',
    platformInstagram: 'Instagram',
    platformVoletaje: 'Voletaje',
    saveTypes: 'Save Types',
    editType: 'Edit Type',
    deleteType: 'Delete Type',
    confirmDeleteType: 'Are you sure you want to delete this type?',
    searchPlaceholder: 'Search by platform name...',
    rotation: 'Rotation',
    angleDegrees: 'Angle (degrees)',
    backgroundColor: 'Background Color',
    colorCode: 'Color Code',
    displayType: 'Display Type',
    flyer: 'Flyer',
    image: 'Image',
    nothing: 'Nothing',
  },
  compensationdashboard: {
    individualTitle: 'Compensation Dashboard',
    globalTitle: 'Global Ambassador Compensation Dashboard',
    loading: 'Loading compensations...',
    loadingStats: 'Loading statistics...',
    close: 'Close',
    totalRevenue: 'Total Revenue',
    tagsSold: 'Tags Sold',
    signedSponsors: 'Signed Sponsors',
    pendingCompensations: 'Pending Compensations',
    compensationHistory: 'Compensation History',
    noCompensations: 'No compensations registered for this ambassador.',
    type: 'Type',
    amount: 'Amount',
    tagsSoldHeader: 'Tags Sold',
    revenueGenerated: 'Revenue Generated',
    status: 'Status',
    date: 'Date',
    tagSale: 'Tag Sale',
    sponsorSigning: 'Sponsor Signing',
    bonus: 'Bonus',
    pending: 'Pending',
    paid: 'Paid',
    totalCompensations: 'Total Compensations',
    totalRevenueGenerated: 'Total Revenue Generated',
    totalPaid: 'Total Paid',
    totalPending: 'Total Pending',
    totalTagsSold: 'Total Tags Sold',
    compensations: 'compensations',
    topByRevenue: 'Top Ambassadors by Revenue Generated',
    topByTags: 'Top Ambassadors by Tags Sold',
    topBySponsors: 'Top Ambassadors by Signed Sponsors',
    ambassador: 'Ambassador',
    email: 'Email',
    revenueGeneratedHeader: 'Revenue Generated',
    compensationsHeader: 'Compensations',
    noCompensationData: 'No compensation data available',
    noAmbassadorsWithSponsors: 'No ambassadors with signed sponsors',
    distributionByType: 'Distribution by Compensation Type',
    count: 'Count',
    totalAmount: 'Total Amount',
    noCompensationsRegistered: 'No compensations registered',
    errorLoadingStats: 'Could not load global compensation statistics',
  },
  sponsortierreport: {
    title: 'Sponsor Tier Report',
    loadingStats: 'Loading statistics...',
    close: 'Close',
    generalStats: 'General Statistics',
    totalSponsors: 'Total Sponsors',
    active: 'Active',
    inactive: 'Inactive',
    totalRevenue: 'Total Revenue',
    tagsAssigned: 'Tags Assigned',
    distributionByTier: 'Distribution by Tier',
    revenueByTier: 'Revenue by Tier',
    sponsorsDistributionByTier: 'Sponsors Distribution by Tier',
    tier: 'Tier',
    totalSponsorsHeader: 'Total Sponsors',
    activeHeader: 'Active',
    inactiveHeader: 'Inactive',
    revenue: 'Revenue',
    tagsAssignedHeader: 'Tags Assigned',
    potentialRevenue: 'Potential Revenue',
    efficiency: 'Efficiency',
    tagsSoldByTier: 'Tags Sold by Tier',
    tagsSold: 'Tags Sold',
    revenueFromTags: 'Revenue from Tags',
    noStatsAvailable: 'No sponsor statistics available.',
    gold: 'Gold',
    silver: 'Silver',
    bronze: 'Bronze',
  },
  benefactor: {
    section_title: 'Benefactors (optional)',
    section_description: 'Declare who benefits from this contest\'s proceeds. You can add organizations, foundations, causes, or rescue groups.',
    enable_label: 'This contest benefits one or more organizations',
    add_shelter: 'Add shelter from directory',
    shelter_help: 'Select a verified NAPC shelter',
    name_label: 'Organization or cause name',
    name_help: 'e.g. "Venezuela earthquake victims", "Lost pets rescue fund"',
    no_name_error: 'Please enter a name',
    category_label: 'Type',
    add_btn: 'Add',
    select_existing: 'Select from previous benefactors',
    select_existing_help: 'Reuse a benefactor already created in another contest',
    loading: 'Loading...',
    no_saved: 'No saved benefactors yet — add one below and save the contest',
    cat: {
      organization: 'Organization',
      foundation: 'Foundation',
      cause: 'Cause / Campaign',
      rescue: 'Rescue group',
      other: 'Other',
    },
  },
};
